import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import { useContext } from 'react';

import { RangePicker } from 'app/components/fields/dayjsPickers';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { DEFAULT_SLOT, formatDayjsToTimeRange, formatToDayjs } from './utils';

type TimeSlotsEditorProps = {
  timeSlotName: (string | number)[];
  addLabel?: string | React.ReactNode;
  showAddButton?: boolean;
  showRemoveButton?: boolean;
  onAllDayClick?: () => void;
  allDayLabel?: string;
};

export const TimeSlotsEditor = ({
  timeSlotName,
  addLabel = <PlusOutlined />,
  showAddButton = true,
  showRemoveButton = true,
  onAllDayClick,
  allDayLabel = '24/24',
}: TimeSlotsEditorProps) => {
  const { isViewMode, isEditMode } = useContext(ViewEditModeContext);

  return (
    <div className="time-slots-editor">
      <Form.List name={timeSlotName}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, idx) => (
              <div key={field.key} className="time-slot-item">
                <Form.Item
                  name={[field.name]}
                  rules={[{ required: true, message: 'Required' }]}
                  getValueFromEvent={(dayjsRange) =>
                    formatDayjsToTimeRange(dayjsRange)
                  }
                  getValueProps={(value) => {
                    if (
                      Array.isArray(value) &&
                      value.length === 2 &&
                      value[0]?.format &&
                      value[1]?.format
                    ) {
                      return { value };
                    }

                    return {
                      value: value ? formatToDayjs(value) : undefined,
                    };
                  }}
                >
                  <RangePicker
                    picker="time"
                    format="HH:mm"
                    minuteStep={30}
                    disabled={isViewMode}
                    renderExtraFooter={() => (
                      <Button size="small" onClick={onAllDayClick}>
                        {allDayLabel}
                      </Button>
                    )}
                  />
                </Form.Item>
                {isEditMode && (
                  <div className="time-slot-actions">
                    {showAddButton && idx === 0 && (
                      <Button type="dashed" onClick={() => add(DEFAULT_SLOT)}>
                        {addLabel}
                      </Button>
                    )}
                    {showRemoveButton && idx > 0 && (
                      <DeleteOutlined onClick={() => remove(idx)} />
                    )}
                  </div>
                )}
              </div>
            ))}
            {isEditMode && showAddButton && fields.length === 0 && (
              <div className="time-slot-actions">
                <Button type="dashed" onClick={() => add(DEFAULT_SLOT)}>
                  {addLabel}
                </Button>
              </div>
            )}
          </>
        )}
      </Form.List>
    </div>
  );
};
